export const FETCH_DASHBOARD_LIST = "FETCH_DASHBOARD_LIST";
export const SET_SELECTED_DASHBOARD = "SET_SELECTED_DASHBOARD";
export const SAVE_DASHBOARD = "SAVE_DASHBOARD";
export const CREATE_DASHBOARD = "CREATE_DASHBOARD";
export const FETCH_AVAILABLE_SINGLES = "FETCH_AVAILABLE_SINGLES";
export const DELETE_DASHBOARD = "DELETE_DASHBOARD";
export const FETCH_PANELDATA = "FETCH_PANELDATA"